// FlagForReviewModal.jsx - Modal for a marker to flag a submission for head marker review
import React from 'react';

function FlagForReviewModal({
  submissionId,
  onClose,
  flagComment,
  setFlagComment,
  onFlag,
  headMarkerName = 'the head marker'
}) {
  if (!submissionId) return null;

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 999
        }}
      />

      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        zIndex: 1000,
        minWidth: '500px'
      }}>
        <h3 style={{ margin: '0 0 16px 0', color: '#2c3e50' }}>
          Flag for Review
        </h3>
        <p style={{ color: '#7f8c8d', marginBottom: '16px' }}>
          Explain the issue for {headMarkerName}. They'll be able to review this submission, send it back to you, or release it back to the available pool.
        </p>

        <textarea
          value={flagComment}
          onChange={(e) => setFlagComment(e.target.value)}
          placeholder="e.g. Student has only submitted part of this homework and plans to upload the rest..."
          style={{
            width: '100%',
            minHeight: '120px',
            padding: '12px',
            border: '2px solid #ecf0f1',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'inherit',
            marginBottom: '16px',
            resize: 'vertical'
          }}
        />

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              background: '#ecf0f1',
              color: '#2c3e50',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Cancel
          </button>

          <button
            onClick={() => onFlag(submissionId)}
            disabled={!flagComment.trim()}
            style={{
              padding: '12px 24px',
              background: flagComment.trim() ? '#f39c12' : '#95a5a6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: flagComment.trim() ? 'pointer' : 'not-allowed',
              fontWeight: '600'
            }}
          >
            Flag for Review
          </button>
        </div>
      </div>
    </>
  );
}

export default FlagForReviewModal;
